import React from 'react'
import AmountOffPricingInputs from '../AmountOff/AmountOffPricingInputs'
import PurchaseConditions from '../AmountOff/PurchaseConditions'
import MaxUsesPerOrder from '../../../MaxUsesPerOrder'
import { useLocale } from 'src/lib/hooks/useLocal'

const DiscountApplicationRulesExitCoupon = () => {
  const { t } = useLocale()
  return (
    <div className='flex flex-col gap-3 w-full'>
      <h3 className='text-text-sm-semibold text-zinc-800'>{t('discounts_v2.set_discount')}</h3>

      <AmountOffPricingInputs showUpto={true} />

      <PurchaseConditions />

      <MaxUsesPerOrder />
    </div>
  )
}

export default DiscountApplicationRulesExitCoupon
